import TranslationKeyForm from './translations-form'

export default TranslationKeyForm;